import { createSignal, onMount } from 'solid-js'
import { Portal } from 'solid-js/web'
import { res2json } from '@/utils'
import * as constants from '@lib/constants'
import * as games from '@games'
import { addToast } from '@/components/Toast'
import account from '@/store/account'

export default function Game() {
  const [betMethod, setBetMethod] = createSignal(games.nob5.defaultBetMethod)
  const [closeTime, setCloseTime] = createSignal(constants.defaultReservedCloseTime)
  const [callDelay, setCallDelay] = createSignal(constants.defaultCallDelay)

  const [loading, setLoading] = createSignal(true)
  const [sending, setSending] = createSignal(false)
  const [errors, setErrors] = createSignal({})

  async function load() {
    setLoading(true)
    fetch(`/api/${account().game_code}/settings/game-play`).then(res2json).then(r => {
      setBetMethod(r.data?.bet_method ?? games.nob5.defaultBetMethod)
      setCloseTime(r.data?.close_time ?? constants.defaultReservedCloseTime)
      setCallDelay(r.data?.call_delay ?? constants.defaultCallDelay)
    }).finally(() => { setLoading(false) })
  }
  onMount(() => {
    load()
  })

  async function submit(e) {
    e.preventDefault()
    if (sending()) {
      return false
    }
    setSending(true)
    return fetch(`/api/${account().game_code}/settings/game-play`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        bet_method: betMethod(),
        close_time: closeTime(),
        call_delay: callDelay()
      })
    }).then(res2json).then(() => {
      addToast({ message: '已保存' })
    }).finally(() => { setSending(false) })
  }

  function reset() {
    if (sending()) {
      return false
    }
    setSending(true)
    fetch(`/api/${account().game_code}/settings/game-play`, {
      method: 'DELETE'
    }).then(res2json).then(() => load()).then(() => {
      addToast({ message: '已重置' })
    }).finally(() => { setSending(false) })
  }

  return (
    <>
      <div class="flex flex-col gap-4">
        <div class="breadcrumbs text-sm">
          <ul>
            <li><a href="/home">后台首页</a></li>
            <li>盘口设定</li>
          </ul>
        </div>
        <h2 class="text-xl">盘口设定</h2>
        <form onSubmit={submit} class="flex flex-col lg:w-1/3 gap-4">
          {account().fixed && (
            <div class="form-control">
              <div class="label"><span class="label-text">默认玩法</span></div>
              <select name="default_bet_method" onChange={e => setBetMethod(e.target.value)} class="w-full select select-bordered">
                <option value="" selected={betMethod() === ''} disabled>请选择默认玩法</option>
                {Object.entries(games.nob5.betMethods).map(([k, v]) => (
                  <option value={k} selected={betMethod() === k}>{v}</option>
                ))}
              </select>
            </div>
          )}
          <div class="form-control">
            <div class="label"><span class="label-text">预留封盘</span></div>
            <label class="input input-bordered flex items-center gap-2">
              <input type="number" name="close_time" value={closeTime()} onChange={e => setCloseTime(parseInt(e.target.value))} min={constants.minCloseTime} max={constants.maxCloseTime} class="grow" />
              <span>秒</span>
            </label>
          </div>
          <div class="form-control">
            <div class="label"><span class="label-text">延迟报网</span></div>
            <label class="input input-bordered flex items-center gap-2">
              <input type="number" name="call_delay" value={callDelay()} onChange={e => setCallDelay(parseInt(e.target.value))} min={constants.minCallDelay} max={constants.maxCallDelay} class="grow" />
              <span>秒</span>
            </label>
          </div>
          <div class="grid grid-cols-2 gap-4 pt-4">
            <button type="button" onClick={() => reset()} class="btn w-full" disabled={sending()}>重置预设值</button>
            <button type="submit" class="btn btn-success text-white w-full" disabled={sending()}>保存</button>
          </div>
        </form>
      </div>

      <Portal mount={document.body}>
        {loading() && (<div class="fixed left-2 right-2 bottom-0"><progress class="progress progress-success w-full"></progress></div>)}
      </Portal>
    </>
  )
}
